var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHaptikIntelligentAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#464646"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91424 12.1421H9.83174C9.66547 12.1256 9.50878 12.0565 9.38444 11.9449C9.2601 11.8333 9.17459 11.6849 9.14031 11.5214L8.08746 6.64211L7.00317 9.15639C6.9725 9.22667 6.92194 9.28643 6.85771 9.32832C6.79349 9.3702 6.71842 9.39238 6.64174 9.39211H5.46317C5.35898 9.39211 5.25905 9.35072 5.18538 9.27704C5.1117 9.20337 5.07031 9.10344 5.07031 8.99925C5.07031 8.89506 5.1117 8.79514 5.18538 8.72146C5.25905 8.64778 5.35898 8.60639 5.46317 8.60639H6.38246L7.36853 6.33175C7.43491 6.17911 7.54804 6.0515 7.69163 5.9673C7.83521 5.88311 8.00183 5.84669 8.16744 5.8633C8.33306 5.8799 8.48913 5.94867 8.61314 6.0597C8.73715 6.17072 8.8227 6.31826 8.85746 6.48104L9.91031 11.3564L10.9946 8.84997C11.0241 8.77822 11.0741 8.71681 11.1384 8.67346C11.2028 8.63012 11.2785 8.60678 11.356 8.60639H12.5346C12.6388 8.60639 12.7387 8.64778 12.8124 8.72146C12.8861 8.79514 12.9275 8.89506 12.9275 8.99925C12.9275 9.10344 12.8861 9.20337 12.8124 9.27704C12.7387 9.35072 12.6388 9.39211 12.5346 9.39211H11.6153L10.6292 11.6668C10.569 11.8068 10.4694 11.9263 10.3424 12.0107C10.2155 12.0951 10.0667 12.1408 9.91424 12.1421Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaptikIntelligentAnalytics);
export default __webpack_public_path__ + "static/media/haptik-intelligent-analytics.fe5dbe3b.svg";
export { ForwardRef as ReactComponent };